// Checks for local storage tokens signaling a previous connection to Auth0
function localStorageAuthTokenCheck() {
  // Prepare for checking authorization
  let localAuthTokenCheck = false;
  // Verify all the proper access variables are present for proper authorization
  if (localStorage.getItem('access_token') && localStorage.getItem('id_token') && localStorage.getItem('expires_at')) {
    // Check whether the current time is past the Access Token's expiry time
    let expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    // set localAuthTokenCheck true if unexpired / false if expired
    localAuthTokenCheck = new Date().getTime() < expiresAt;
  }

  return localAuthTokenCheck;
}

export default localStorageAuthTokenCheck;
